module.exports = __webpack_public_path__ + "img/OverseaMember54.4bbaa958.jpg";